import { render, staticRenderFns } from "./OctList.vue?vue&type=template&id=7cd4d9f6&scoped=true&"
import script from "./OctList.vue?vue&type=script&lang=js&"
export * from "./OctList.vue?vue&type=script&lang=js&"
import style0 from "./OctList.vue?vue&type=style&index=0&id=7cd4d9f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd4d9f6",
  null
  
)

export default component.exports